import Cookies from 'universal-cookie';
import ErrorHandler from '~/glm/utils/error-handler';

const GDS_API_ENDPOINT = process.env.REACT_APP_GLM_GDS_API_ENDPOINT;
const GDS_API_KEY = process.env.REACT_APP_GLM_GDS_API_KEY;

export default class GdsApi {
  static cookies = new Cookies();

  static get(path) {
    return GdsApi.baseFetch(path, {
      method: 'GET',
      headers: GdsApi.baseHeaders(),
    });
  }

  static post(path, params) {
    return GdsApi.baseFetch(path, {
      method: 'POST',
      headers: GdsApi.baseHeaders(),
      body: JSON.stringify(params),
    });
  }

  static put(path, params) {
    return GdsApi.baseFetch(path, {
      method: 'PUT',
      headers: GdsApi.baseHeaders(),
      body: JSON.stringify(params),
    });
  }

  static patch(path, params) {
    return GdsApi.baseFetch(path, {
      method: 'PATCH',
      headers: GdsApi.baseHeaders(),
      body: JSON.stringify(params),
    });
  }

  static delete(path, params) {
    return GdsApi.baseFetch(path, {
      method: 'DELETE',
      headers: GdsApi.baseHeaders(),
      body: params && JSON.stringify(params),
    });
  }

  static parseResponse(response) {
    if (response && response.ok) {
      if (response.status === 200) {
        return response.json();
      } else {
        return Promise.resolve();
      }
    }

    try {
      return new Promise((_, reject) => {
        response.text().then(text => (text ? reject(JSON.parse(text)) : {}));
      });
    } catch (err) {
      return Promise.reject();
    }
  }

  static handleRejectedFetch({ path, request, error }) {
    // regex to fingerprint properly https://rubular.com/r/QUhag0em4e6AJB
    const uuidRegex = /\/[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}/gi;
    const endPoint = path.replace(uuidRegex, '');
    const name = `GdsApi Error - ${endPoint}`;
    ErrorHandler.notify({
      name,
      context: { path, request },
      fingerprint: name,
      triggerHandleErrorCallback: true,
      message: error.error,
    });
  }

  static baseHeaders() {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'MEMBERSHIP-SESSION-TOKEN': this.getSessionToken(),
      'X-API-KEY': GDS_API_KEY, // eslint-disable-line no-undef
    };
  }

  static getSessionToken() {
    if (!GdsApi.cookies) {
      GdsApi.cookies = new Cookies();
    }
    return GdsApi.cookies.get('xo-session-token');
  }

  static baseFetch(path, request) {
    return fetch(`${GDS_API_ENDPOINT}${path}`, request) // eslint-disable-line no-undef
      .then(GdsApi.parseResponse)
      .catch(error => {
        GdsApi.handleRejectedFetch({ path, request, error });
        return Promise.reject(error);
      });
  }
}
